export default __webpack_public_path__ + "media/images/brighteon-social/Icon-AI-Gray-de50f6e2e0be5ca212b804876fb48a64.svg";